import React, { useEffect } from "react";
import "./assets/fonts/font.css";
import { BrowserRouter } from "react-router-dom";
import AppRouter from "./AppRouter";
import { QueryClientProvider } from "react-query";
import ApiService from "./services/ApiService";
import { StyleSheetManager } from "styled-components";
import { ColorProvider } from "@cinesys/ui/components";
import {
  UpdateComponentsJobProvider,
  useUpdateComponentsJob,
} from "./context/UpdateComponentsJobContext";
import UpdateComponentsJobToast from "./components/UpdateComponentsJobToast";

const DevTools = () => {
  const { simulateJob } = useUpdateComponentsJob();
  useEffect(() => {
    (window as any).__simulateJob = simulateJob;
  }, [simulateJob]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <StyleSheetManager shouldForwardProp={() => true}>
        <QueryClientProvider client={ApiService.queryClient}>
          <ColorProvider>
            <UpdateComponentsJobProvider>
              <AppRouter></AppRouter>
              <UpdateComponentsJobToast />
              <DevTools />
            </UpdateComponentsJobProvider>
          </ColorProvider>
        </QueryClientProvider>
      </StyleSheetManager>
    </BrowserRouter>
  );
}

export default App;
